module.exports = __webpack_public_path__ + "media/images/covid/banner/sidebar/ko-16b23c4c3fc571cf1d0c90457a0d3975.jpg";